import { useBlockPageOverflow } from '@App/hooks/useBlockPageOverflow'

import { AlertsList } from '@UI/crypto_exchange/desktop/pages/all_alerts/components/AlertsList'

export const AllAlerts = () => {
  useBlockPageOverflow()
  return <AlertsList />
}
